module.exports = __webpack_public_path__ + "img/awards2018mozaiku_white.05b67e58.jpg";